"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Result;
    }
});
let Result = class Result {
    constructor(code = 0, message = '', data = {}, sql_code){
        this.code = code;
        this.message = message;
        this.data = data;
        this.sql_code = sql_code;
    }
};
